<template>
  <div class="activation-code-chart">
    <div class="activation-code-chart-header">
      <div class="chart-header-left">
        <i></i>
        <span>{{ echartType }}</span>
      </div>
      <div class="chart-header-right">
        <DateUnit v-model="unitType" :needText="false" />
      </div>
    </div>
    <div class="activation-code-chart-main">
      <div class="chart-main-left" :style="{ background: `url(${leftBg})` }">
        <div class="chart-main-left-type">{{ leftType }}</div>
        <div class="chart-main-left-total">{{ leftTotal }}</div>
      </div>
      <div v-loading="!show" class="chart-main-right">
        <Echart
          v-if="show"
          :el="echartEl"
          :hasStat="hasStat"
          :options="echartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import DateUnit from '../common/DateUnit'
import Echart from '../common/Echart'
import constant from '@/utils/constant'

export default {
  name: 'ActivationCodeChart',
  components: {
    DateUnit,
    Echart,
  },
  props: {
    echartType: {
      type: String,
      default: '',
    },
    leftType: {
      type: String,
      default: '',
    },
    leftBg: {
      type: String,
      default: '',
    },
    getStatFunc: {
      type: Function,
      default() {
        return () => {}
      },
    },
  },
  data() {
    return {
      show: false,
      unitType: '',
      statOptions: {},
    }
  },
  computed: {
    ...mapGetters({
      isLarge: 'customer/isLarge',
      userDetail: 'customer/userDetail',
    }),
    formatStartAt() {
      let startAt = constant.startDate
      const agentStartTime = moment(
        _.get(this.userDetail, 'agent.createdAt', new Date())
      )
      if (moment(agentStartTime) > moment(startAt)) {
        startAt = agentStartTime
      }
      return startAt
    },
    echartEl() {
      return this.statOptions.echartEl
    },
    hasStat() {
      return this.statOptions.hasStat
    },
    echartOptions() {
      return this.statOptions.echartOptions
    },
    leftTotal() {
      return this.statOptions.leftTotal || 0
    },
  },
  watch: {
    unitType(unit) {
      let startTime = ''
      let endTime = ''
      const yesterdayDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      if (unit === 'day') {
        startTime = moment().subtract(7, 'days').format('YYYY-MM-DD')
        endTime = yesterdayDate
      }
      if (unit === 'week') {
        startTime = moment().subtract(7, 'weeks').format('YYYY-MM-DD')
        endTime = yesterdayDate
      }
      if (unit === 'month') {
        startTime = moment().startOf('year').format('YYYY-MM-DD')
        endTime = yesterdayDate
      }
      if (startTime < this.formatStartAt) {
        startTime = this.formatStartAt
      }
      const params = {
        unit,
        startTime,
        endTime,
      }
      this.onGetStatFunc(params)
    },
    isLarge() {
      if (this.$route.name === 'ActivationCode') {
        this.refreshChart()
      }
    },
  },
  created() {
    this.unitType = 'day'
  },
  methods: {
    async onGetStatFunc(params) {
      this.hideChart()
      this.statOptions = await this.getStatFunc(params)
      this.showChart()
    },
    refreshChart() {
      this.hideChart()
      this.showChart()
    },
    hideChart() {
      this.show = false
    },
    showChart() {
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>

<style lang='scss'>
.activation-code-chart {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
  border-radius: 4px;
  .activation-code-chart-header {
    display: flex;
    justify-content: space-between;
    height: 50px;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 20px;
    .chart-header-left {
      display: flex;
      align-items: center;
      i {
        background-color: #2397f3;
        border-radius: 2px;
        width: 4px;
        height: 15px;
        margin-right: 10px;
      }
    }
  }
  .activation-code-chart-main {
    padding-left: 20px;
    display: flex;
    height: 288px;
    justify-content: space-between;
    .chart-main-left {
      width: 30%;
      box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
      border-radius: 4px;
      height: 142px;
      padding: 28px 28px;
      margin-top: 40px;
      box-sizing: border-box;
      color: #fff;
      .chart-main-left-total {
        font-size: 40px;
        margin-top: 16px;
      }
    }
    .chart-main-right {
      width: 60%;
    }
  }
}
</style>